<template>
  <div>
    <div class="flex justify-between">
      <div>
        <h4>Training Record</h4>
      </div>

      <div class="logo">
        <img
          :src="logo"
          alt="Training Port"
        >
      </div>
    </div>

    <div class="mt-10 flex justify-between">
      <div>
        <b class="text-2xl">Company: </b>
        <p class="text-2xl">
          {{ user.company.name }}
        </p>
      </div>

      <div>
        <b class="text-2xl">Name: </b>
        <p class="text-2xl">
          {{ user.fullName }}
        </p>
      </div>

      <div>
        <b class="text-2xl">
          Registry, Purpose, Equipment
        </b>
        <p
          v-for="rpe in user.company.rpe"
          :key="rpe.id"
          class="text-2xl"
        >
          {{ rpe.name }}
        </p>
      </div>

      <div>
        <b class="text-2xl">Roles</b>
        <ul class="list-unstyled">
          <li
            v-for="role in user.company.roles"
            :key="role.id"
          >
            <span class="text-2xl">
              {{ role.name }}
            </span>
            <p class="ml-xs text-2xl">
              <span class="text-gray-500">Licence:</span>
              <b class="ml-xxxs">{{ role.licence }}</b>
            </p>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <table class="mt-10 table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th
              scope="col"
              class="text-center"
            >
              <b class="text-2xl">Name</b>
            </th>
            <th
              scope="col"
              class="text-center"
            >
              <b class="text-2xl">Periodicity</b>
            </th>
            <th
              scope="col"
              class="text-center"
            >
              <b class="text-2xl">Completed At</b>
            </th>
            <th
              scope="col"
              class="text-center"
            >
              <b class="text-2xl">Expiry At</b>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="topic in list"
            :key="topic.id"
          >
            <th scope="row">
              <div class="flex">
                <Icon
                  :type="topic.topicStatus"
                  class="mr-2"
                />

                <div class="mr-3">
                  {{ topic.topicName }}
                </div>

                <Icon
                  v-for="condition in topic.conditions"
                  :key="condition"
                  class="mr-2"
                  :type="condition"
                />
              </div>
            </th>
            <td class="text-center">
              {{ topic.periodicity }}
            </td>
            <td class="text-center">
              {{ formatDate(topic.completed_at) }}
            </td>
            <td class="text-center">
              {{ formatDate(topic.expiry) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import label from "@consts/label";
import HelperDate from "@helpers/dates";
import Icon from "@components/UIComponents/TopicIcon/Icon";
import mapper from "@components/UIComponents/TopicIcon/mapper.json";

export default {
  components: {
    Icon
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    records: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      logo: label.companySecondVersionLogo
    };
  },
  computed: {
    list() {
      return this.parseData(this.records);
    }
  },
  methods: {
    parseData(data) {
      return data.map(topic => {
        return {
          id: topic.id,
          conditions: this.getIconConditions(topic),
          topicStatus: this.getStatus(topic.status),
          topicName: topic.topicName,
          periodicity: topic.periodicity,
          completed_at: this.formatDate(topic.completed_at),
          expiry: this.formatDate(topic.expiry),
          lessons: topic.lessons
        };
      });
    },
    getIconConditions(topic) {
      const conditions = ["seasonal", "compressed", "expiration"];
      return conditions.filter(cond => topic[cond]);
    },
    getStatus(status) {
      if (!status) {
        return;
      }

      const stringfiedStatus = String(status);

      const [iconName] = Object.entries(mapper).find(([, value]) => {
        return value.code === stringfiedStatus;
      });

      const rejectStatus = ["completed"];

      if (rejectStatus.includes(iconName)) {
        return;
      }

      return iconName;
    },
    formatDate(date) {
      return HelperDate.formatDate(date);
    },
    formatDateTime(date) {
      return HelperDate.formatDateTime(date);
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 200px;
  margin-top: 30px;
}

@media print {
  .table {
    border-collapse: inherit !important;
  }
  .table > tbody > tr {
    position: static;
  }

  @page {
    size: letter portrait;
    max-height: 99%;
    max-width: 99%;
  }
}
</style>
